import LogLevels from '../constants/logLevels';

const secured = window.mailFeedbackEnv.secure;
const httpLabel = 'http' + (secured ? 's' : '');

export default {
  build: '25',
  version: '1.0.0',
  server: {
    mailFeedbackEndpoint: httpLabel + '://' + window.mailFeedbackEnv.endpoints.mailFeedback
  },
  ui: {
    branding: window.mailFeedbackEnv.branding,
  },
  recaptcha: window.mailFeedbackEnv.recaptcha,
  logLevel: LogLevels[window.mailFeedbackEnv.logLevel.toLowerCase().trim()],
}